import { render, staticRenderFns } from "./hot-comments.vue?vue&type=template&id=273ae681&scoped=true&"
import script from "./hot-comments.vue?vue&type=script&lang=js&"
export * from "./hot-comments.vue?vue&type=script&lang=js&"
import style0 from "./hot-comments.vue?vue&type=style&index=0&id=273ae681&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273ae681",
  null
  
)

export default component.exports